import * as Sentry from '@sentry/react';
import { getBaseHostConfig } from '@bynder/sentry-main-client';
import packageJson from '../package.json';
import { envVar } from 'packages/helpers/envVar';
import { getEnvironment } from 'packages/helpers/getEnvironment';

const appVersion = packageJson.version;

const WASM_REDACTED = 'data:application/wasm;(REPLACED_MANUALLY_FOR_MEMORY_SAVE)';

// Stale tabs after a deploy, not defects.
export const IGNORED_ERRORS = [
    /ChunkLoadError/,
    /Loading (CSS )?chunk [\w-]+ failed/,
    /Failed to fetch dynamically imported module/,
    /error loading dynamically imported module/,
];

export const redactWasmBreadcrumbs = <T extends Sentry.ErrorEvent>(event: T): T => {
    event.breadcrumbs?.forEach((breadcrumb) => {
        if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.includes('data:application/wasm;')) {
            breadcrumb.data.url = WASM_REDACTED;
        }
    });

    return event;
};

export const initSentry = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
        return;
    }

    const { sentryDsn } = envVar;
    const environment = getEnvironment();

    if (Sentry.getClient()?.getOptions().dsn === sentryDsn) {
        return;
    }

    // The base config overrides `integrations`, `beforeSend` and `tracesSampleRate`, so extend
    // it after the call instead of passing those in.
    const baseConfig = getBaseHostConfig({
        environment,
        release: `studio@${appVersion}`,
        dist: appVersion,
        dsn: sentryDsn,
        ignoreErrors: IGNORED_ERRORS,
    });

    Sentry.init({
        ...baseConfig,
        beforeSend: (event) => baseConfig.beforeSend(redactWasmBreadcrumbs(event)),
    });
};
